import React, { useState } from 'react';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setFormData({ name: '', email: '', phone: '', message: '' });
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <div className="bg-white min-h-screen">
        <section className="py-16 px-8 md:px-[140px] bg-gradient-to-b from-[#8e0707] to-[#6b0505]">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-medium text-white mb-4">
              Contact Us
            </h1>
            <p className="text-xl text-white/80">
              Ask for help, support, queries, or compliment here!
            </p>
          </div>
        </section>

        <section className="py-16 px-8 md:px-[140px]">
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">
            <div>
              <h2 className="text-3xl font-bold text-[#272727] mb-8">Get in Touch</h2>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#8e0707] rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white">📞</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#272727] mb-1">Phone</h3>
                    <p className="text-[#272727]/70">+91 6263957789</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#8e0707] rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white">✉️</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#272727] mb-1">Email</h3>
                    <p className="text-[#272727]/70">Sunkissedtaste@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#8e0707] rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white">📍</span>
                  </div>
                  <div>
                    <h3 className="font-bold text-[#272727] mb-1">Location</h3>
                    <p className="text-[#272727]/70">India</p>
                  </div>
                </div>
              </div>

              <div className="mt-12 p-6 bg-[#f8f8f8] rounded-lg">
                <h3 className="font-bold text-[#272727] mb-2">Business Hours</h3>
                <p className="text-[#272727]/70">Monday - Saturday: 9:00 AM - 6:00 PM</p>
                <p className="text-[#272727]/70">Sunday: Closed</p>
              </div>
            </div>

            <div>
              <h2 className="text-3xl font-bold text-[#272727] mb-8">Send a Message</h2>
              
              {submitted ? (
                <div className="p-8 bg-green-50 border border-green-200 rounded-lg text-center">
                  <span className="text-4xl mb-4 block">✓</span>
                  <h3 className="text-xl font-bold text-green-700 mb-2">Thank you!</h3>
                  <p className="text-green-600">We'll get back to you soon.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Name</label>
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      placeholder="Your name"
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Email</label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                      placeholder="your@email.com"
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Phone</label>
                    <input
                      type="tel"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                      placeholder="+91 XXXXXXXXXX"
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-[#272727] mb-2">Message</label>
                    <textarea
                      value={formData.message}
                      onChange={(e) => setFormData({...formData, message: e.target.value})}
                      placeholder="How can we help you?"
                      required
                      rows={5}
                      className="w-full px-4 py-2 border border-gray-300 rounded"
                    />
                  </div>

                  <button type="submit" className="w-full bg-[#8e0707] hover:bg-[#6b0505] text-white py-3 rounded">
                    Send Message
                  </button>
                </form>
              )}
            </div>
          </div>
        </section>
    </div>
  );
};

export default ContactPage;
